import { useEffect } from 'react';

export const useWindowFocus = (cb: () => void) => {
  useEffect(() => {
    window.addEventListener('focus', cb);

    return () => {
      window.removeEventListener('focus', cb);
    };
  }, [cb]);
};
